import Overview from "@/components/admin/Content/WebPages/ContactUs/Overview";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import { useWebPageForm } from "@/contexts/WebPageFormContext";

const ContactUs = () => {
  const { pageData, isLoading } = useWebPageForm();

  if (isLoading) {
    return <FullPageSpinner />;
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 xl:w-3/4 mx-auto">
      <Overview data={pageData?.CONTACT_US_INFO ?? {
        sectionTag: 'CONTACT_US_INFO',
        contentType: 'CONTACT_INFO',
        sectionTitle: 'Contact Information',
        title: 'Get in Touch'
      }} />
    </div>
  )
}

export default ContactUs